import { useTranslation } from '@mypoz/i18n';
import { Card } from '@mypoz/ui';

import { useFormat } from '@/lib/format.js';

/** RM 100 — the old website's minimum per request. Not returned by any endpoint (API issues, item 6). */
const MINIMUM_RM_CENTS = 10_000;

/**
 * Processing times and limits, as the old website's China Payment pages state them. Fixed text:
 * no endpoint returns them (China Payment API issues, item 6), so this only informs — nothing in
 * the app enforces it.
 *
 * `sameDayFromRmbCents` is per service: ¥1,000 for top-ups and transfers, ¥3,000 for proxy pay.
 */
export function ProcessingTimesCard({ sameDayFromRmbCents }: { sameDayFromRmbCents: number }) {
  const { t } = useTranslation();
  const fmt = useFormat();

  return (
    <Card>
      <h2 className="text-base font-semibold text-ink">{t('chinaPayment.hours.title')}</h2>
      <ul className="mt-3 grid list-disc gap-1.5 pl-5 text-sm text-ink marker:text-muted">
        <li>{t('chinaPayment.hours.weekdays')}</li>
        <li>{t('chinaPayment.hours.saturday')}</li>
        <li>{t('chinaPayment.hours.sunday')}</li>
        <li>
          {t('chinaPayment.hours.sameDay', { threshold: fmt.money(sameDayFromRmbCents, 'RMB') })}
        </li>
        <li>{t('chinaPayment.hours.minimum', { amount: fmt.money(MINIMUM_RM_CENTS, 'RM') })}</li>
        <li>{t('chinaPayment.hours.noUrgent')}</li>
      </ul>
    </Card>
  );
}
